// Who we are, as far as the client has any part in it: the only place in the client that knows how people sign in (see
// api/identity on the server). With Tailscale (or any signing-in proxy) the browser does nothing: the proxy tells the
// server. Signing in as a development player (the server's "dev" way, development builds only) sends the player picked
// on the front page with every request, remembered in this browser.
const DevUserKey = 'tta-dev-user';
const Development = process.env.NODE_ENV !== 'production';

const devUser = () => {
    if (!Development) return null;
    try { return window.localStorage.getItem(DevUserKey); } catch { return null; }
};

// Headers that say who we are, added to every request
export const IdentityHeaders = () => {
    const dev = devUser();
    return dev ? { 'X-Dev-User': dev } : {};
};

// The same for an event stream, which cannot send headers: added to its address ('' or '?...')
export const IdentityQuery = () => {
    const dev = devUser();
    return dev ? `?devUser=${encodeURIComponent(dev)}` : '';
};

// Be someone else (when the server's /games/me says we may: switchable), then start over as them
export const SwitchUser = (login) => {
    try { window.localStorage.setItem(DevUserKey, login); } catch { /* (then the server's default player) */ }
    window.location.reload();
};
